import { AdminApiService } from '../services';

export type IntegrationInfoType = {
  internal_service_token?: string;
};

export const getIntegrationInfo = (): Promise<IntegrationInfoType> => {
  return AdminApiService.getIntegrationInfoApiAdminIntegrationInfoGet();
};

export const sendChatToServer = (contact_id: string, chat: string) => {
  return AdminApiService.submitHumanInputApiAdminHumanInputPost({
    contact_id,
    message: chat,
  });
};
